import React, { useContext } from 'react';
import CustomLink from '../CustomLink';
import { SubmenuProps } from './interfaces';
import './styles.scss';
import SspProviderContext from '../../utils/SspProvider/context';
import SSPContentVO from 'sspcontentext/dist/model/SSPContentVO';
import { getHighlights } from '../../pages/Expose/utils/getHighlights';
import i18next from 'i18next';

export default function Submenu(props: SubmenuProps) {
    const store = useContext(SspProviderContext);
    const contentModel = store.state.content ? store.state.content.asModel : new SSPContentVO('').asModel;
    const storyItems = contentModel.reflist('StoryItems');
    const productionAndLogistics: SSPContentVO[] = storyItems.filter(
        item => item.asModel.target.Kategorie === 'products_logistics'
    );
    const traditionAndMilestones: SSPContentVO[] = storyItems.filter(
        item => item.asModel.target.Kategorie === 'tradition_milestones'
    );
    const technologyAndInnovation: SSPContentVO[] = storyItems.filter(
        item => item.asModel.target.Kategorie === 'technology_innovations'
    );
    const sustainabilityAndSocial: SSPContentVO[] = storyItems.filter(
        item => item.asModel.target.Kategorie === 'sustainability_social'
    );
    const sportAndDynamic: SSPContentVO[] = storyItems.filter(
        item => item.asModel.target.Kategorie === 'sport_dynamic'
    );

    const handleclose = () => {
        props.setMenuOpen(false);
        setTimeout(() => {
            props.setIsVisible();
        }, 3000);
    };

    return (
        <div className={`submenu ${props.isVisible ? 'visible' : 'hidden'}`}>
            <div className='text-area'>
                <ul className='list'>
                    {props.activeSublist === 1 && (
                        <>
                            <div className='menu-item-wrapper'>
                                <span className='main-link-active bold'>MEIN FAHRZEUG</span>
                            </div>

                            <li className='sub-list'>
                                <ul>
                                    <CustomLink to='/#overview'>
                                        <li
                                            onClick={() => {
                                                handleclose();
                                            }}
                                        >
                                            <span>{i18next.t('Overview')}</span>
                                            <svg className='icon-24'>
                                                <use xlinkHref='#as-arrow-right' />
                                            </svg>
                                        </li>
                                    </CustomLink>
                                    {getHighlights(contentModel).length > 0 && (
                                        <CustomLink to='/#highlights'>
                                            <li
                                                onClick={() => {
                                                    handleclose();
                                                }}
                                            >
                                                <span>{i18next.t('Highlights')}</span>
                                                <svg className='icon-24'>
                                                    <use xlinkHref='#as-arrow-right' />
                                                </svg>
                                            </li>
                                        </CustomLink>
                                    )}
                                    <CustomLink to='/#gallery'>
                                        <li
                                            onClick={() => {
                                                handleclose();
                                            }}
                                        >
                                            <span>{i18next.t('Gallery')}</span>
                                            <svg className='icon-24'>
                                                <use xlinkHref='#as-arrow-right' />
                                            </svg>
                                        </li>
                                    </CustomLink>
                                    <CustomLink to='/#details'>
                                        <li
                                            onClick={() => {
                                                handleclose();
                                            }}
                                        >
                                            <span>{i18next.t('Details')}</span>
                                            <svg className='icon-24'>
                                                <use xlinkHref='#as-arrow-right' />
                                            </svg>
                                        </li>
                                    </CustomLink>
                                    <CustomLink to='/#links'>
                                        <li
                                            onClick={() => {
                                                handleclose();
                                            }}
                                        >
                                            <span>{i18next.t('Links')}</span>
                                            <svg className='icon-24'>
                                                <use xlinkHref='#as-arrow-right' />
                                            </svg>
                                        </li>
                                    </CustomLink>
                                </ul>
                            </li>
                        </>
                    )}

                    {props.activeSublist === 3 && (
                        <>
                            <div className='menu-item-wrapper'>
                                <span className='main-link-active bold'>MEINE ERLEBNISABHOLUNG</span>
                            </div>

                            <li className='sub-list'>
                                <ul>
                                    <CustomLink to='/pick-up#intro'>
                                        <li
                                            onClick={() => {
                                                handleclose();
                                            }}
                                        >
                                            <span>{i18next.t('Overview')}</span>
                                            <svg className='icon-24'>
                                                <use xlinkHref='#as-arrow-right' />
                                            </svg>
                                        </li>
                                    </CustomLink>
                                    <CustomLink to='/pick-up#organizational'>
                                        <li
                                            onClick={() => {
                                                handleclose();
                                            }}
                                        >
                                            <span>{i18next.t('Organizational')}</span>
                                            <svg className='icon-24'>
                                                <use xlinkHref='#as-arrow-right' />
                                            </svg>
                                        </li>
                                    </CustomLink>
                                    <CustomLink to='/pick-up#day-planning'>
                                        <li
                                            onClick={() => {
                                                handleclose();
                                            }}
                                        >
                                            <span>{i18next.t('DayPlanning')}</span>
                                            <svg className='icon-24'>
                                                <use xlinkHref='#as-arrow-right' />
                                            </svg>
                                        </li>
                                    </CustomLink>
                                    <CustomLink to='/pick-up#ritz-carlton'>
                                        <li
                                            onClick={() => {
                                                handleclose();
                                            }}
                                        >
                                            <span>{i18next.t('RitzCarlton')}</span>
                                            <svg className='icon-24'>
                                                <use xlinkHref='#as-arrow-right' />
                                            </svg>
                                        </li>
                                    </CustomLink>
                                    <CustomLink to='/pick-up#additional-services'>
                                        <li
                                            onClick={() => {
                                                handleclose();
                                            }}
                                        >
                                            <span>{i18next.t('AdditionalServices')}</span>
                                            <svg className='icon-24'>
                                                <use xlinkHref='#as-arrow-right' />
                                            </svg>
                                        </li>
                                    </CustomLink>
                                    <CustomLink to='/pick-up#pick-up-day'>
                                        <li
                                            onClick={() => {
                                                handleclose();
                                            }}
                                        >
                                            <span>{i18next.t('DayOfPickUp')}</span>
                                            <svg className='icon-24'>
                                                <use xlinkHref='#as-arrow-right' />
                                            </svg>
                                        </li>
                                    </CustomLink>
                                </ul>
                            </li>
                        </>
                    )}
                    {props.activeSublist === 2 && props.editorialContent && (
                        <>
                            <div className='menu-item-wrapper'>
                                <span className='main-link-active bold'>VOLKSWAGEN</span>
                            </div>

                            <li className='sub-list'>
                                <ul>
                                    <CustomLink to='/story#story'>
                                        <li
                                            onClick={() => {
                                                handleclose();
                                            }}
                                        >
                                            <span>{i18next.t('Overview')}</span>
                                            <svg className='icon-24'>
                                                <use xlinkHref='#as-arrow-right' />
                                            </svg>
                                        </li>
                                    </CustomLink>
                                    {productionAndLogistics.length > 0 && (
                                        <CustomLink to='/story#production-and-logistics'>
                                            <li
                                                onClick={() => {
                                                    handleclose();
                                                }}
                                            >
                                                <span>{i18next.t('ProductionAndLogistics')}</span>
                                                <svg className='icon-24'>
                                                    <use xlinkHref='#as-arrow-right' />
                                                </svg>
                                            </li>
                                        </CustomLink>
                                    )}
                                    {traditionAndMilestones.length > 0 && (
                                        <CustomLink to='/story#tradition-and-milestones'>
                                            <li
                                                onClick={() => {
                                                    handleclose();
                                                }}
                                            >
                                                <span>{i18next.t('TraditionAndMilestones')}</span>
                                                <svg className='icon-24'>
                                                    <use xlinkHref='#as-arrow-right' />
                                                </svg>
                                            </li>
                                        </CustomLink>
                                    )}
                                    {technologyAndInnovation.length > 0 && (
                                        <CustomLink to='/story#technology-and-innovation'>
                                            <li
                                                onClick={() => {
                                                    handleclose();
                                                }}
                                            >
                                                <span>{i18next.t('TechnologyAndInnovation')}</span>
                                                <svg className='icon-24'>
                                                    <use xlinkHref='#as-arrow-right' />
                                                </svg>
                                            </li>
                                        </CustomLink>
                                    )}

                                    {sustainabilityAndSocial.length > 0 && (
                                        <CustomLink to='/story#sustainability-and-social'>
                                            <li
                                                onClick={() => {
                                                    handleclose();
                                                }}
                                            >
                                                <span>{i18next.t('SustainabilityAndSocial')}</span>
                                                <svg className='icon-24'>
                                                    <use xlinkHref='#as-arrow-right' />
                                                </svg>
                                            </li>
                                        </CustomLink>
                                    )}
                                    {sportAndDynamic.length > 0 && (
                                        <CustomLink to='/story#vehicle-in-autostadt'>
                                            <li
                                                onClick={() => {
                                                    handleclose();
                                                }}
                                            >
                                                <span>{i18next.t('SportAndDynamic')}</span>
                                                <svg className='icon-24'>
                                                    <use xlinkHref='#as-arrow-right' />
                                                </svg>
                                            </li>
                                        </CustomLink>
                                    )}

                                    <CustomLink to='/story#fun-and-facts'>
                                        <li
                                            onClick={() => {
                                                handleclose();
                                            }}
                                        >
                                            <span>{i18next.t('FunAndFacts')}</span>
                                            <svg className='icon-24'>
                                                <use xlinkHref='#as-arrow-right' />
                                            </svg>
                                        </li>
                                    </CustomLink>
                                </ul>
                            </li>
                        </>
                    )}
                </ul>
            </div>
            <div className='menu-close-container'>
                <button
                    className={`icon-24 close-button-menu ${props.activeSublist !== 0 ? ' close-sub-list' : ''}`}
                    aria-label='Schließen'
                    onClick={() => {
                        handleclose();
                    }}
                >
                    <svg>
                        <use xlinkHref='#as-close' />
                    </svg>
                </button>
            </div>

            <div className='goback-btn' onClick={() => props.setIsVisible()}>
                <svg className='icon-24'>
                    <use xlinkHref='#as-chevron' />
                </svg>
                <span>Zurück</span>
            </div>
        </div>
    );
}
